// For info on how to create dashboard cards refer to docs/DASHBOARD_CARDS.md
import { Skeleton, Typography } from '@/ui';

import HomeCard from './HomeCard';
import { useHomeCardsContext } from './HomeCardsContext';
import {
  isBookableCoachCard,
  isMomentsScheduledCoach,
  MeetCoachCardGate,
} from './homeCardGates';

const MAX_HOME_CARDS = 5;

const ForYouHeading = () => (
  <Typography
    className="mb-6 px-4 font-bold text-white md:px-0"
    component="h2"
    variant="h5"
  >
    For you
  </Typography>
);

/**
 * The "For you" carousel. Full-width coach booking cards render separately and
 * higher up the page — see CoachBookingCards.
 */
const Cards = () => {
  const {
    appointments,
    appointmentState,
    cards,
    isLoading,
    now,
    matchStateForCoach,
    onDismiss,
    refetch,
  } = useHomeCardsContext();

  if (isLoading) {
    return (
      <div className="mt-4 md:mt-0">
        <ForYouHeading />
        <div className="flex min-h-104 gap-4 overflow-x-auto pb-4 pl-4 first:pl-2 last:pr-12">
          <Skeleton
            animation="wave"
            className="w-64 bg-cement-400 opacity-25"
            height={414}
            variant="rounded"
          />
          <Skeleton
            animation="wave"
            className="w-64 bg-cement-400 opacity-25"
            height={414}
            variant="rounded"
          />
          <Skeleton
            animation="wave"
            className="w-64 bg-cement-400 opacity-25"
            height={414}
            variant="rounded"
          />
        </div>
      </div>
    );
  }

  const carouselCards = cards
    .filter(
      (card) => !isBookableCoachCard(card) || !isMomentsScheduledCoach(card),
    )
    .slice(0, MAX_HOME_CARDS);

  if (carouselCards.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 md:mt-0">
      <ForYouHeading />
      {/* Standard card carousel */}
      <div
        className="flex min-h-104 gap-4 overflow-x-auto pb-4 pl-4 first:pl-2 last:pr-12"
        data-testid="card-holder"
      >
        {/* Non-Moments coach booking cards retain the legacy scheduler. */}
        {carouselCards.map((card) =>
          isBookableCoachCard(card) ? (
            <MeetCoachCardGate
              key={card.id}
              appointments={appointments}
              appointmentState={appointmentState}
              card={card}
              matchState={matchStateForCoach(card.coach?.id ?? '')}
              now={now}
              variant="carousel"
              {...card}
              refetch={refetch}
              onDismiss={onDismiss}
            />
          ) : (
            <HomeCard
              key={card.id}
              {...card}
              refetch={refetch}
              onDismiss={onDismiss}
            />
          ),
        )}
      </div>
    </div>
  );
};

export default Cards;
